<template>
  <g-map-advanced-marker
    v-for="retailer in displayedRetailers"
    :key="retailer.key"
    :position="retailer.position"
    :icon="retailer.icon"
    :title="retailer.Retailer?.Names?.[0]"
    no-draw
    @click="$emit('activate-marker', retailer)"
    @added="onChanged"
    @removed="onChanged"
  />
</template>

<script setup lang="ts">
import { debounce } from 'throttle-debounce';
import { GMapAdvancedMarker } from 'vue-google-maps-community-fork';

defineOptions({
  name: 'MapMarkersFi',
});

const emit = defineEmits<{
  'activate-marker': [retailer: any];
  redraw: [];
}>();

defineProps<{
  displayedRetailers: any[];
}>();

const onChanged = debounce(100, () => emit('redraw'));
</script>
